import { render, staticRenderFns } from "./CarbonSelect.vue?vue&type=template&id=5b74b3f3&scoped=true"
import script from "./CarbonSelect.vue?vue&type=script&lang=js"
export * from "./CarbonSelect.vue?vue&type=script&lang=js"
import style0 from "./CarbonSelect.vue?vue&type=style&index=0&id=5b74b3f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b74b3f3",
  null
  
)

export default component.exports